/*
The MIT License (MIT)

Copyright (c) 2015 Ilya Gelman

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

https://github.com/ilyagelman/redux-sessionstorage
*/

import createSlicer from './createSlicer.js';

/**
 * @description
 * persistState is a Store Enhancer that syncs (a subset of) store state to sessionStorage.
 *
 * @param {String|String[]} [paths] Specify keys to sync with sessionStorage, if left undefined the whole store is persisted
 * @param {Object} [config] Optional config object
 * @param {String} [config.key="redux"] String used as sessionStorage key
 * @param {Function} [config.serialize=JSON.stringify] (subset) => serializedData. Called just before persisting to
 * sessionStorage. Should transform the subset into a format that can be stored.
 * persistedState from sessionStorage. Should transform the data into the format expected by your application
 *
 * @return {Function} An enhanced store
 */
export default function persistState(paths, config) {
  const cfg = {
    key: 'redux',
    slicer: createSlicer,
    serialize: JSON.stringify,
    ...config,
  };

  const { key, slicer, serialize } = cfg;

  return next => (reducer, initialState, ...args) => {
    const store = next(reducer, initialState, ...args);
    const slicerFn = slicer(paths);

    store.subscribe(function () {
      const state = store.getState();
      const subset = slicerFn(state);

      sessionStorage.setItem(key, serialize(subset));
    });

    return store;
  };
}
